import { render, staticRenderFns } from "./loginFreeTips.vue?vue&type=template&id=195e6b40&scoped=true&"
import script from "./loginFreeTips.vue?vue&type=script&lang=js&"
export * from "./loginFreeTips.vue?vue&type=script&lang=js&"
import style0 from "./loginFreeTips.vue?vue&type=style&index=0&id=195e6b40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195e6b40",
  null
  
)

export default component.exports